import { render, staticRenderFns } from "./PDPModalVipWelcome.vue?vue&type=template&id=1034d112&scoped=true"
import script from "./PDPModalVipWelcome.vue?vue&type=script&lang=js"
export * from "./PDPModalVipWelcome.vue?vue&type=script&lang=js"
import style0 from "./PDPModalVipWelcome.vue?vue&type=style&index=0&id=1034d112&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1034d112",
  null
  
)

export default component.exports